import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import { Button, Checkbox, Dimmer, Form, Loader, Modal, Segment } from 'semantic-ui-react'
import 'styled-components/macro'
import { useHistory, useLocation } from 'react-router'
import { useTranslation } from 'react-i18next'
import SignatureModal from '../Profile/signatureModal'
import { timezones } from '../Profile/countries'
import axios from '../axios'
import { useDispatch, useSelector } from 'react-redux'
import { formData } from '../shared/formDataCreator'
import { uiActions } from '../store/ui-slice'
import { url_environment } from '../config'
import { payment_date_options } from '../Profile/proposal-freelancer'

const ProposalModal = (props) => {
    const [t, i18n] = useTranslation("global")
    const location = useLocation()
    const [files, setFiles] = useState([])
    const [loading, setLoading] = useState(false)
    const [sigImage, setSigImage] = useState(undefined)
    const [sigImageLink, setSigImageLink] = useState(undefined)
    const [showSignatureModal, setShowSignatureModal] = useState(false)
    const [vendorServices, setVendorServices] = useState([])
    const dispatch = useDispatch();
    const [filesData, setFilesData] = useState([])
    const data = props.data
    const { userInfo } = useSelector(state => state.user)
    const fileRef = useRef(undefined)
    const history = useHistory()
    const changeTracker = useRef([])
    const [copyValues, setCopyValues] = useState()
    const getFilesObject = useCallback((array) => {
        const obj = {}
        const n = array.length
        for (let i = 0; i < n; i++) {
            obj[`file-${(i + 1)}`] = array[i]
        }
        return obj
    }, [])
    const handleAcceptChange = (e, a) => {
        const { name, checked, value } = a
        changeTracker.current.push(name)
        if (checked)
            setValues(p => { return { ...p, [name]: value } })
        else
            setValues(p => { return { ...p, [name]: copyValues[name] } })
    }
    const pass = useCallback((data) => {
        if (
            data.searching_for == "" ||
            data.job_scope_work == "" ||
            data.select_payment_schedule == "" ||
            (data.select_payment_schedule == "monthly" && data.payment_date == "") ||
            data.proposed_hourly_rate == "" ||
            data.requirements == "" ||
            data.timeline == "" ||
            data.timezone == "" ||
            data.requested_availability.length == 0 ||
            data.requested_available_days.length == 0 ||
            data.requested_available_times.length == 0 ||
            data.additional_information == "" ||
            !data.sigImageLink
        ) return false
        return true
    }, [])
    const handleSaveClick = async (submit) => {
        if (submit) {
            console.log("submit: ", submit)
            if (!pass({ ...values, sigImageLink })) { alert("Please fill all required fields"); return; }
        }
        const config = {
            headers: {
                Authorization: `Bearer ${userInfo.token}`,
            },
        }
        try {
            setLoading(true)
            const temp = { ...values }
            temp.business_options = undefined
            temp.sent = false
            temp.requested_availability = JSON.stringify(temp.requested_availability)
            temp.requested_available_days = JSON.stringify(temp.requested_available_days)
            temp.requested_available_times = JSON.stringify(temp.requested_available_times)
            let changeTrack = [...changeTracker.current]
            changeTracker.current = []
            changeTrack = changeTrack.filter(function (item, pos) {
                return changeTrack.indexOf(item) == pos;
            })
            const temp2 = {}
            changeTrack.forEach(x => {
                temp2[x] = temp[x]
            })
            await axios.put("/api/proposal/update", formData({
                ...temp2,
                ...getFilesObject(files),
                sigImage,
                sent: submit ? true : false,
                proposal_id: data._id
            }), config)
            props.update()
            props.close()
        } catch (e) {
            alert(e)
        }
        setLoading(false)
    }
    const showCounterData = () => {
        if (
            data.counter_response_to_job ||
            data.counter_offer_hourly_rate ||
            data.counter_requirements ||
            data.counter_timeline ||
            data.counter_meeting_schedule ||
            data.counter_requested_availability.length > 0 ||
            data.counter_requested_available_days.length > 0 ||
            data.counter_requested_available_times.length > 0 ||
            data.counter_payment_date > 0 ||
            data.counter_payment_schedule
        ) return true
        return false
    }
    const handleCheckboxChange = useCallback((e, a) => {
        const { name, checked, value } = a
        changeTracker.current.push(name)
        // debugger;
        setValues(prev => {
            let arr = []
            if (checked) {
                return { ...prev, [name]: [...prev[name], value] }
            } else {
                arr = prev[name].filter((i) => { return i !== value });
                return { ...prev, [name]: arr }
            }
        })
        setCopyValues(prev => {
            let arr = []
            if (checked) {
                return { ...prev, [name]: [...prev[name], value] }
            } else {
                arr = prev[name].filter((i) => { return i !== value });
                return { ...prev, [name]: arr }
            }
        })
    }, [])
    const handleSignatureSubmit = useCallback((image) => {
        setSigImage(image)
        setSigImageLink(image)
    }, [])
    const handleSignatureModalClose = useCallback(() => {
        setShowSignatureModal(false)
    }, [])
    const handleAddFileClick = useCallback(() => {
        fileRef.current.click()
    }, [])
    const handleSignatureClick = useCallback(() => {
        setShowSignatureModal(true)
    }, [])
    const handleSelectChange = useCallback((e, a) => {
        const { name, value } = a
        setValues(p => { return { ...p, [name]: value } })
        setCopyValues(p => { return { ...p, [name]: value } })
        changeTracker.current.push(name)
    }, [])
    const handleImageLoad = (e) => URL.revokeObjectURL(e.target.src)
    const handleFileChange = useCallback((e) => {
        const f = e.target.files[0]
        if (!f) return;
        setFiles(p => [...p, f])
        setFilesData(p => [
            ...p,
            {
                name: f.name,
                type: f.type,
                image_link: f.type.startsWith("image") ? URL.createObjectURL(f) : undefined
            }
        ])

    }, [])
    const [values, setValues] = useState({
        counter_requested_availability: [], counter_requested_available_days: [], counter_requested_available_times: [], business_name: "", link_to_website: "", searching_for: "", requested_availability: [], requested_available_days: [], requested_available_times: [], job_description: "", payment_date: 1, select_payment_schedule: "hourly", proposed_hourly_rate: "", requirements: "", timeline: ""
    })
    const handleInputChange = useCallback((e) => {
        setValues(p => { return { ...p, [e.target.name]: e.target.value } })
        setCopyValues(p => { return { ...p, [e.target.name]: e.target.value } })
        changeTracker.current.push(e.target.name)
    }, [])
    const handleRadioChange = useCallback((e, a) => {
        const { name, checked, value } = a
        // debugger;
        changeTracker.current.push(name)
        setValues(prev => {
            return { ...prev, [name]: value }
        })
    }, [])
    useEffect(() => {
        if (!props.open) return;
        if (Object.keys(props.data).length == 0) return
        setValues({
            ...data,
            link_to_website: data.link_to_website,
            searching_for: data.service_name,
            job_scope_work: data.job_scope_work,
            payment_date: data.payment_date,
            select_payment_schedule: data.payment_schedule,
            proposed_hourly_rate: data.proposed_hourly_rate,
            requirements: data.requirements,
            timeline: data.timeline,
            meeting_schedule: data.meeting_schedule,
            timezone: data.timezone,
            requested_availability: data.requested_availability,
            requested_available_days: data.requested_available_days,
            requested_available_times: data.requested_available_times,
            additional_information: data.additional_information,
        })
        setCopyValues({
            ...data,
            link_to_website: data.link_to_website,
            searching_for: data.service_name,
            job_scope_work: data.job_scope_work,
            payment_date: data.payment_date,
            select_payment_schedule: data.payment_schedule,
            proposed_hourly_rate: data.proposed_hourly_rate,
            requirements: data.requirements,
            timeline: data.timeline,
            meeting_schedule: data.meeting_schedule,
            timezone: data.timezone,
            requested_availability: data.requested_availability,
            requested_available_days: data.requested_available_days,
            requested_available_times: data.requested_available_times,
            additional_information: data.additional_information,
        })
        setFilesData(data.files.map(x => { const ss = x.substring(x.lastIndexOf(".") + 1); const t = ss != "pdf" ? "image" : "pdf"; return { name: x.substring(x.lastIndexOf("/") + 1), type: t, image_link: url_environment + x } }))
        setSigImageLink(url_environment + data.signature_sender)
    }, [props.open])
    const cleanState = () => {
        setValues({})
        setFilesData([])
    }
    const handleMessageClick = () => {
        dispatch(uiActions.change_action({ open: true, action: "new message", receiver: { vendor: { ...data.receiver }, product: { service_name: data.service_name, images: [data.service_image] }, subject: "About service", link: `/service/${data.service}` } }))
    }
    if (loading) {
        return <Dimmer active inverted>
            <Loader />
        </Dimmer>
    }
    if (Object.keys(props.data).length == 0) return <></>
    return (
        <>
            <Modal
                closeIcon
                closeOnDimmerClick={false}
                onClose={props.close}
                open={props.open}
            >
                <Modal.Header>{data.receiver.freelancer_name}</Modal.Header>
                <Modal.Content >
                    <div css="display:flex;justify-content:space-between;@media(max-width:660px){flex-direction:column;align-items:center;}">
                        <div css="display:flex;">
                            <div css="font-size:25px;font-weight:700;display:flex;align-items:center;color:teal;margin-right:35px;@media(max-width:500px){display:none;}">{t("contractmgmt.to")}:</div>
                            <div css="display:flex;align-items:center;@media(max-width:500px){flex-direction:column;align-items:center;}">
                                <img css="width:150px;height:150px;border-radius:100%;object-fit:cover;object-position:center;margin-right:15px;" src={`${url_environment}${data.receiver.freelancer_picture}`} alt="" />
                                <div>
                                    <div css="margin:10px 0;">{data.receiver.freelancer_name}</div>
                                    <div css="margin:10px 0;">{data.receiver.category_name}</div>
                                </div>
                            </div>
                        </div>
                        <div css="display:flex;align-items:flex-end;">
                            <Button onClick={handleMessageClick} css="margin-top:20px !important;" circular color="teal">{t("contractmgmt.direct_message")}</Button>
                        </div>
                    </div>
                    <div css="height:2px;background-color:rgb(2,183,178);margin:20px 0;"></div>
                    <h2 css="text-align:center;color:rgb(2,183,178);margin:2rem 0;">{t("contractmgmt.proposal")}: #{data._id}</h2>
                    <p css="margin-top:0.7rem;margin-bottom:2rem;font-weight:bold;color:#800000;">
                        {t("contractmgmt.please_note_that")}
                    </p>
                    <p css="margin-top:0.7rem;margin-bottom:2rem;font-weight:bold;">
                        {t("contractmgmt.important_carefully_read_para")}
                    </p>
                    <div css="display:flex;flex-wrap:wrap;max-width:1000px; margin:0 auto;">
                        <div css="flex:0 0 auto;width:50%;margin-bottom:1em;padding-right:50px;@media(max-width:768px){width:100%;padding:0;}">
                            <div className="ui form">
                                <Form.Input
                                    label={t("contractmgmt.link_to_website")}
                                    value={values.link_to_website}
                                    name="link_to_website"
                                    onChange={handleInputChange}
                                />
                                <div className="ui required field">
                                    <label>{t("contractmgmt.searching_for")}</label>
                                    <Segment>{values.searching_for}</Segment>
                                </div>
                                <Form.TextArea
                                    required
                                    label={t("contractmgmt.job_scope_work")}
                                    value={values.job_scope_work}
                                    name="job_scope_work"
                                    onChange={handleInputChange}
                                    rows={10}
                                />
                                <div className="ui field">
                                    <input onChange={handleFileChange} type="file" accept="image/*,application/pdf" hidden ref={fileRef} />
                                    <label>{t("contractmgmt.sample_desired_work")}</label>
                                    <div css="display:flex;align-items:center;justify-content:flex-start;">
                                        <div>
                                            <div css="display:flex;flex-wrap:wrap;justify-content:flex-start;">
                                                <div onClick={handleAddFileClick} css="cursor:pointer;flex:0 0 auto;/*width:25%;*/width:112px;height:104px;padding:6px;/*@media(max-width:1000px){width:33.333333%;}@media(max-width:800px){width:50%;}*/">
                                                    <div css="/*padding-bottom:90%;*/height:100%;position:relative;box-shadow: 0 1px 2px 0 rgb(34 36 38 / 15%);border: 1px solid rgba(34,36,38,.15);">
                                                        <div css="/*position:absolute;*/width:100%;height:100%;display:flex;align-items:center;justify-content:center;">
                                                            <div css="display:flex;flex-direction:column;align-items:center;">
                                                                <p css="text-align:center;margin:0;margin-bottom:5px;">Add a file</p>
                                                                <i className="ui big file icon"></i>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                {filesData.map((item) => {
                                                    return <>
                                                        <a href={item.image_link} target="_blank" css="display:block;flex:0 0 auto;/*width:25%;*/width:112px;height:104px;padding:6px;/*@media(max-width:1000px){width:33.333333%;}@media(max-width:800px){width:50%;}*/">
                                                            <div css="/*padding-bottom:90%;*/height:100%;position:relative;box-shadow: 0 1px 2px 0 rgb(34 36 38 / 15%);border: 1px solid rgba(34,36,38,.15);">
                                                                <div css="/*position:absolute;*/width:100%;height:100%;display:flex;align-items:center;justify-content:center;width: 100%;">
                                                                    {!item.type.startsWith("image") && <div css="display:flex;flex-direction:column;width:100%;">
                                                                        <div>
                                                                            <p css="text-align:center;margin:0;margin-bottom:5px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;">{item.name}</p>
                                                                        </div>
                                                                        <div css="text-align:center;"><i className="ui big file pdf icon"></i></div>
                                                                    </div>}
                                                                    {item.type.startsWith("image") && <div css="display:flex;flex-direction:column;align-items:center;width: 100%;height: 100%;">
                                                                        <img src={item.image_link} css="width:100%;height:100%;object-fit:cover;object-position:center;" alt="" onLoad={handleImageLoad} />
                                                                    </div>}
                                                                </div>
                                                            </div>
                                                        </a>
                                                    </>
                                                })}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="ui required field">
                                    <label>{t("contractmgmt.select_payment_schedule")}</label>
                                    <div css="display:flex;flex-wrap:wrap;justify-content:flex-start;margin-left:-2px;margin-right:-2px;">
                                        <div css="flex:0 0 auto;width:120px;padding:5px 2px;">
                                            <Checkbox type='radio' checked={values.select_payment_schedule === "hourly"} value="hourly" name="select_payment_schedule" onChange={handleRadioChange} label={t("contractmgmt.hourly")} />
                                        </div>
                                        <div css="flex:0 0 auto;width:120px;padding:5px 2px;">
                                            <Checkbox type='radio' checked={values.select_payment_schedule === "weekly"} value="weekly" name="select_payment_schedule" onChange={handleRadioChange} label={t("contractmgmt.weekly")} />
                                        </div>
                                        <div css="flex:0 0 auto;width:120px;padding:5px 2px;">
                                            <Checkbox type='radio' checked={values.select_payment_schedule === "monthly"} value="monthly" name="select_payment_schedule" onChange={handleRadioChange} label={t("contractmgmt.monthly")} />
                                        </div>
                                        <div css="flex:0 0 auto;width:120px;padding:5px 2px;">
                                            <Checkbox type='radio' checked={values.select_payment_schedule === "one_time"} value="one_time" name="select_payment_schedule" onChange={handleRadioChange} label={t("contractmgmt.one_time")} />
                                        </div>
                                    </div>
                                </div>
                                <Form.Input
                                    required
                                    icon="dollar sign"
                                    iconPosition="left"
                                    type="number"
                                    label={t("contractmgmt.proposed_" + values.select_payment_schedule + (values.select_payment_schedule == "one_time" ? "_payment_amount" : "_rate"))}
                                    name="proposed_hourly_rate"
                                    value={values.proposed_hourly_rate}
                                    onChange={handleInputChange}
                                />
                                {values.select_payment_schedule == "monthly" && <div className="ui required field">
                                    <label>{t("contractmgmt.payment_date")}</label>
                                    <Form.Select
                                        fluid
                                        options={payment_date_options}
                                        onChange={handleSelectChange}
                                        name="payment_date"
                                        value={values.payment_date}
                                    />
                                </div>}
                                <div className="ui required field">
                                    <label>
                                        {t("contractmgmt.requirements")}<br />
                                        {t("contractmgmt.what_do_you_require_para")}<br />
                                        {t("contractmgmt.what_do_you_require_example")}
                                    </label>
                                    <textarea
                                        name="requirements"
                                        value={values.requirements}
                                        onChange={handleInputChange}
                                    />
                                </div>
                                <div className="ui required field">
                                    <label>{t("contractmgmt.timeline")}</label>
                                    <label>{t("contractmgmt.meeting_schedule_paragraph")}</label>
                                    <textarea
                                        name="timeline"
                                        value={values.timeline}
                                        onChange={handleInputChange}
                                    />
                                </div>
                                {data.sent && <>
                                    <div className="ui  field">
                                        <label>{t("contractmgmt.freelancer_requirements")}</label>
                                        <textarea
                                            value={values.freelancer_requirements}
                                            readOnly
                                        />
                                    </div>
                                    <div className="ui  field">
                                        <label>{t("contractmgmt.freelancer_additional_information")}</label>
                                        <textarea
                                            value={values.freelancer_additional_information}
                                            readOnly
                                        />
                                    </div>
                                </>}
                            </div>
                        </div>
                        <div css="flex:0 0 auto;width:50%;margin-bottom:1em;padding-left:50px;@media(max-width:768px){width:100%;padding:0;}">
                            <div className="ui form">

                                <div className="ui required field">
                                    <label>{t("contractmgmt.meeting_schedule")}</label>
                                    {/* <label>{t("contractmgmt.meeting_schedule_paragraph")}</label> */}
                                    <textarea
                                        name="meeting_schedule"
                                        value={values.meeting_schedule}
                                        onChange={handleInputChange}
                                    />
                                </div>
                                <div className="ui required field">
                                    <label>{t("contractmgmt.timezone")}</label>
                                    <label>{t("contractmgmt.what_time_zone_para")}</label>
                                    <Form.Select
                                        fluid
                                        options={timezones}
                                        onChange={handleSelectChange}
                                        name="timezone"
                                        value={values.timezone}
                                    />
                                </div>
                                <div className="ui required field">
                                    <label>{t("contractmgmt.requested_availability")}</label>
                                    <div css="display:flex;flex-wrap:wrap;">
                                        <div css="padding:5px 0;width:100%;">
                                            <Checkbox label={t("contractmgmt.full_time")} checked={values.requested_availability.indexOf("Full time") !== -1} value="Full time" name="requested_availability" onChange={handleCheckboxChange} />
                                        </div>
                                        <div css="padding:5px 0;width:100%;">
                                            <Checkbox label={t("contractmgmt.part_time")} checked={values.requested_availability.indexOf("Part time") !== -1} value="Part time" name="requested_availability" onChange={handleCheckboxChange} />
                                        </div>
                                    </div>
                                </div>
                                <div className="ui required field">
                                    <label>{t("contractmgmt.requested_available_days")}</label>
                                    <label>{t("contractmgmt.what_days_and_times")}</label>
                                    <div css="display:flex;flex-wrap:wrap;justify-content:flex-start;margin-left:-2px;margin-right:-2px;">
                                        <div css="flex:0 0 auto;width:120px;padding:5px 2px;">
                                            <Checkbox checked={values.requested_available_days.indexOf("Monday") !== -1} value="Monday" name="requested_available_days" onChange={handleCheckboxChange} label={t("contractmgmt.monday")} />
                                        </div>
                                        <div css="flex:0 0 auto;width:120px;padding:5px 2px;">
                                            <Checkbox checked={values.requested_available_days.indexOf("Tuesday") !== -1} value="Tuesday" name="requested_available_days" onChange={handleCheckboxChange} label={t("contractmgmt.tuesday")} />
                                        </div>
                                        <div css="flex:0 0 auto;width:120px;padding:5px 2px;">
                                            <Checkbox checked={values.requested_available_days.indexOf("Wednesday") !== -1} value="Wednesday" name="requested_available_days" onChange={handleCheckboxChange} label={t("contractmgmt.wednesday")} />
                                        </div>
                                        <div css="flex:0 0 auto;width:120px;padding:5px 2px;">
                                            <Checkbox checked={values.requested_available_days.indexOf("Thursday") !== -1} value="Thursday" name="requested_available_days" onChange={handleCheckboxChange} label={t("contractmgmt.thursday")} />
                                        </div>
                                        <div css="flex:0 0 auto;width:120px;padding:5px 2px;">
                                            <Checkbox checked={values.requested_available_days.indexOf("Friday") !== -1} value="Friday" name="requested_available_days" onChange={handleCheckboxChange} label={t("contractmgmt.friday")} />
                                        </div>
                                        <div css="flex:0 0 auto;width:120px;padding:5px 2px;">
                                            <Checkbox checked={values.requested_available_days.indexOf("Saturday") !== -1} value="Saturday" name="requested_available_days" onChange={handleCheckboxChange} label={t("contractmgmt.saturday")} />
                                        </div>
                                        <div css="flex:0 0 auto;width:120px;padding:5px 2px;">
                                            <Checkbox checked={values.requested_available_days.indexOf("Sunday") !== -1} value="Sunday" name="requested_available_days" onChange={handleCheckboxChange} label={t("contractmgmt.sunday")} />
                                        </div>
                                    </div>
                                </div>
                                <div className="ui required field">
                                    <label>{t("contractmgmt.requested_available_times")}</label>
                                    <label>{t("contractmgmt.what_days_and_times")}</label>
                                    <div css="display:flex;flex-wrap:wrap;justify-content:flex-start;margin-left:-2px;margin-right:-2px;">
                                        <div css="flex:0 0 auto;width:120px;padding:5px 2px;">
                                            <Checkbox checked={values.requested_available_times.indexOf("Early") !== -1} value="Early" name="requested_available_times" onChange={handleCheckboxChange} label={t("contractmgmt.early_morning")} />
                                        </div>
                                        <div css="flex:0 0 auto;width:120px;padding:5px 2px;">
                                            <Checkbox checked={values.requested_available_times.indexOf("Morning") !== -1} value="Morning" name="requested_available_times" onChange={handleCheckboxChange} label={t("contractmgmt.morning")} />
                                        </div>
                                        <div css="flex:0 0 auto;width:120px;padding:5px 2px;">
                                            <Checkbox checked={values.requested_available_times.indexOf("Afternoon") !== -1} value="Afternoon" name="requested_available_times" onChange={handleCheckboxChange} label={t("contractmgmt.afternoon")} />
                                        </div>
                                        <div css="flex:0 0 auto;width:120px;padding:5px 2px;">
                                            <Checkbox checked={values.requested_available_times.indexOf("Evening") !== -1} value="Evening" name="requested_available_times" onChange={handleCheckboxChange} label={t("contractmgmt.evening")} />
                                        </div>
                                        <div css="flex:0 0 auto;width:120px;padding:5px 2px;">
                                            <Checkbox checked={values.requested_available_times.indexOf("Night") !== -1} value="Night" name="requested_available_times" onChange={handleCheckboxChange} label={t("contractmgmt.night")} />
                                        </div>
                                    </div>
                                </div>
                                <Form.TextArea
                                    required
                                    label={t("contractmgmt.additional_information")}
                                    name="additional_information"
                                    value={values.additional_information}
                                    onChange={handleInputChange}
                                    rows={10}
                                />
                                <div className="ui required field">
                                    <label>{t("contractmgmt.digital_signature")}</label>
                                    <input type="text" onClick={handleSignatureClick} />
                                </div>
                                {sigImageLink && <div className="ui field">
                                    <div css="padding-bottom:75%;position:relative;">
                                        <img css="position:absolute;top:0;left:0;width:100%;height:100%;border:1px solid #dededf;border-radius:.28571429rem;" src={sigImageLink} alt="" onLoad={handleImageLoad} />
                                    </div>
                                </div>}
                            </div>
                        </div>
                        {showCounterData() && <div css="flex:0 0 auto;width:50%;margin-bottom:1em;padding-left:50px;@media(max-width:768px){width:100%;padding:0;}">
                            <div className="ui form">
                                <h3>{t("contractmgmt.counter_info")}</h3>
                                <hr />
                                {values.counter_response_to_job && (
                                    <div className="ui required field">
                                        <label>{t("contractmgmt.counter_response_to_job")}</label>
                                        <Checkbox name="job_scope_work" value={values.counter_response_to_job} label={t("contractmgmt.accept")} onChange={handleAcceptChange} />
                                        <textarea cols="30" rows="10" readOnly>{values.counter_response_to_job}</textarea>
                                    </div>
                                )}
                                {values.counter_offer_hourly_rate && (
                                    <div className="ui required field">
                                        <label>{t("contractmgmt.counter_offer_" + values.select_payment_schedule + (values.select_payment_schedule == "one_time" ? "_payment_amount" : "_rate"))}</label>
                                        <Checkbox name="proposed_hourly_rate" value={values.counter_offer_hourly_rate} label={t("contractmgmt.accept")} onChange={handleAcceptChange} />
                                        <Segment>USD ${values.counter_offer_hourly_rate}</Segment>
                                    </div>
                                )}
                                {values.counter_requirements && (
                                    <div className="ui required field">
                                        <label>{t("contractmgmt.counter_requirements")}</label>
                                        <Checkbox name="requirements" value={values.counter_requirements} label={t("contractmgmt.accept")} onChange={handleAcceptChange} />
                                        <textarea cols="30" rows="10" readOnly>{values.counter_requirements}</textarea>
                                    </div>
                                )}
                                {values.counter_timeline && (
                                    <div className="ui required field">
                                        <label>{t("contractmgmt.counter_timeline")}</label>
                                        <Checkbox name="timeline" value={values.counter_timeline} label={t("contractmgmt.accept")} onChange={handleAcceptChange} />
                                        <textarea cols="30" rows="10" readOnly>{values.counter_timeline}</textarea>
                                    </div>
                                )}
                                {values.counter_meeting_schedule && (
                                    <div className="ui required field">
                                        <label>{t("contractmgmt.counter_meeting_schedule")}</label>
                                        <Checkbox name="meeting_schedule" value={values.counter_meeting_schedule} label={t("contractmgmt.accept")} onChange={handleAcceptChange} />
                                        <textarea cols="30" rows="10" readOnly>{values.counter_meeting_schedule}</textarea>
                                    </div>
                                )}
                                {values.counter_requested_availability.length > 0 && (
                                    <div className="ui required field">
                                        <label>{t("contractmgmt.counter_requested_availability")}</label>
                                        <Checkbox name="requested_availability" value={values.counter_requested_availability} label={t("contractmgmt.accept")} onChange={handleAcceptChange} />
                                        <Segment>{values.counter_requested_availability.join(", ")}</Segment>
                                    </div>
                                )}
                                {values.counter_requested_available_days.length > 0 && (
                                    <div className="ui required field">
                                        <label>{t("contractmgmt.counter_requested_available_days")}</label>
                                        <Checkbox name="requested_available_days" value={values.counter_requested_available_days} label={t("contractmgmt.accept")} onChange={handleAcceptChange} />
                                        <Segment>{values.counter_requested_available_days.join(", ")}</Segment>
                                    </div>
                                )}
                                {values.counter_requested_available_times.length > 0 && (
                                    <div className="ui required field">
                                        <label>{t("contractmgmt.counter_requested_available_times")}</label>
                                        <Checkbox name="requested_available_times" value={values.counter_requested_available_times} label={t("contractmgmt.accept")} onChange={handleAcceptChange} />
                                        <Segment>{values.counter_requested_available_times.join(", ")}</Segment>
                                    </div>
                                )}
                                {values.counter_payment_schedule && (
                                    <div className="ui required field">
                                        <label>{t("contractmgmt.counter_payment_schedule")}</label>
                                        <Checkbox name="select_payment_schedule" value={values.counter_payment_schedule} label={t("contractmgmt.accept")} onChange={handleAcceptChange} />
                                        <Segment>{t("contractmgmt."+values.counter_payment_schedule)}</Segment>
                                    </div>
                                )}
                                {values.counter_payment_date > 0 && (
                                    <div className="ui required field">
                                        <label>{t("contractmgmt.counter_payment_date")}</label>
                                        <Checkbox name="payment_date" value={values.counter_payment_date} label={t("contractmgmt.accept")} onChange={handleAcceptChange} />
                                        <Segment>{values.counter_payment_date}</Segment>
                                    </div>
                                )}
                                
                            </div>
                        </div>}
                    </div>
                    {props.data.reject_reason && <div className="ui form">
                        <div className="ui field">
                            <label htmlFor="">{t("product.reject_reason")}</label>
                            <Segment>
                                {props.data.reject_reason}
                            </Segment>
                        </div>
                    </div>}
                </Modal.Content>
                <Modal.Actions css="display:flex;justify-content:space-evenly;">
                    <Button disabled={data.approve_status == "pending"} color='teal' circular onClick={() => handleSaveClick(data.sent ? true : false)}>
                        {data.sent ? t("contractmgmt.submit") : t("contractmgmt.save")}
                    </Button>
                    {!data.sent && <Button css="background:rgb(2,183,178) !important;" color='teal' circular onClick={() => handleSaveClick(true)}>
                        {t("contractmgmt.submit")}
                    </Button>}
                    <Button css="background:rgb(0,128,129) !important;" color='teal' circular onClick={props.close}>
                        {t("contractmgmt.close")}
                    </Button>

                </Modal.Actions>
            </Modal>
            <SignatureModal open={showSignatureModal} close={handleSignatureModalClose} submit={handleSignatureSubmit} />
        </>
    )
}

export default ProposalModal